import {createActions} from 'redux-actions';

export const {
    updateDeliveryModeEnabled,
} = createActions({
    UPDATE_DELIVERY_MODE_ENABLED: deliveryModeEnabled => deliveryModeEnabled,
});